import detailHeroMapping from '../components/detailHeroMapping';
import viewRelatedProductComponent from '../components/viewRelatedProductsComponent';

const productDetailMapping = (data) => {
  let pageData = JSON.parse(data['resolvedResource#uri{0}'].body);
  const mappedData = {};
  const components = pageData.data.relationships.field_components.data;
  const relatedComponent = components.find(component => component.type === "paragraph--related_products_component");

  mappedData.productID = pageData.data.attributes.drupal_internal__nid;

  mappedData.hero = detailHeroMapping(components.find(component => {
    return component.type === "paragraph--product_hero_component"
  }));

  if (relatedComponent) {
    mappedData.viewRelatedProduct = viewRelatedProductComponent(relatedComponent);
  }

  return mappedData;
};


export default productDetailMapping;
